import ThemeBuilder from 'hsi/classes/ThemeBuilder';

const elements = ({colors}: ThemeBuilder) => ({
    multipleSearch: {
        chipBg: colors.white,
    },
});

export default elements;
